'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockGeolocatedDynamicMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGeolocated = require('react-geolocated');

var _DynamicMap = require('./DynamicMap');

var _DynamicMap2 = _interopRequireDefault(_DynamicMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */
/* Cannot be stateless because of Geolocation */

var GeolocatedDynamicMap = function (_Component) {
  _inherits(GeolocatedDynamicMap, _Component);

  function GeolocatedDynamicMap() {
    _classCallCheck(this, GeolocatedDynamicMap);

    return _possibleConstructorReturn(this, (GeolocatedDynamicMap.__proto__ || Object.getPrototypeOf(GeolocatedDynamicMap)).apply(this, arguments));
  }

  _createClass(GeolocatedDynamicMap, [{
    key: 'render',
    value: function render() {
      var mapProperties = Object.assign({}, this.props.mapProps);

      if (this.props.isGeolocationEnabled && this.props.coords) {
        var _props$coords = this.props.coords,
            latitude = _props$coords.latitude,
            longitude = _props$coords.longitude;

        if (latitude) {
          mapProperties.geoLatitude = latitude;
        }
        if (longitude) {
          mapProperties.geoLongitude = longitude;
        }
      }

      return _react2.default.createElement(_DynamicMap2.default, mapProperties);
    }
  }]);

  return GeolocatedDynamicMap;
}(_react.Component);

GeolocatedDynamicMap.propTypes = {
  /** A coords object provided by the Geolocation API
   * Provided by a wrapper component by default, no need to specify. */
  coords: _propTypes2.default.object.isRequired,
  /** A boolean that indicated if the browser supports and has enabled Geolocation.
   * Provided by a wrapper component by default, no need to specify. */
  isGeolocationEnabled: _propTypes2.default.bool,
  /** The properties to pass-through to the DynamicMap */
  mapProps: _propTypes2.default.object.isRequired
};
GeolocatedDynamicMap.defaultProps = {
  isGeolocationEnabled: false
};
exports.default = (0, _reactGeolocated.geolocated)({
  userDecisionTimeout: 5000
})(GeolocatedDynamicMap);


var MockGeolocatedDynamicMap = (0, _reactGeolocated.geolocated)({
  userDecisionTimeout: 5000,
  geolocationProvider: {
    getCurrentPosition: function getCurrentPosition(onSuccess) {
      return onSuccess({
        coords: {
          latitude: 50,
          longitude: 20
        }
      });
    },
    watchPosition: function watchPosition(onSuccess) {
      return onSuccess({
        coords: {
          latitude: 50,
          longitude: 20
        }
      });
    }
  }
})(GeolocatedDynamicMap);
exports.MockGeolocatedDynamicMap = MockGeolocatedDynamicMap;
GeolocatedDynamicMap.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'GeolocatedDynamicMap',
  'props': {
    'isGeolocationEnabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'A boolean that indicated if the browser supports and has enabled Geolocation.\nProvided by a wrapper component by default, no need to specify.'
    },
    'coords': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'A coords object provided by the Geolocation API\nProvided by a wrapper component by default, no need to specify.'
    },
    'mapProps': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'The properties to pass-through to the DynamicMap'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/GeolocatedDynamicMap.js
// module id = 588
// module chunks = 0